import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { theme } from '../layout/MaterialLayout';

export default function Header() {

  return (
    <div>
    <AppBar style={{ position: 'fixed',backgroundColor:'#fafafa',color:'#666'}}>
      <Toolbar>
        <IconButton
            color="inherit"
            aria-label="visit Berkeley Foundation"
            edge="start"
            onClick={()=>{ window.open('https://www.berkeleyfoundation.org.uk', '_blank')}}
            sx={{ mr: 2, display: { sm: 'block' } }}
          >
            <img  src="/bgfoundation-logo.png" alt="Berkeley Foundation" title='visit Berkeley Foundation'/>
          </IconButton>
          {false && <div style={{fontSize:theme.typography.pxToRem(34)}}>Newsletter sign-up</div>}
      </Toolbar>
    </AppBar>
     <section style={{ backgroundColor:theme.palette.primary.main, height: 70}}>
      </section>
    </div>
  );
}
